import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SupplierContentReducer(state = initialState.supplierContent, action: any) {
  switch (action.type) {
    case types.SAVE_SUPPLIERCONTENT_SUCCESS:
      return action.supplierContent;
    default:
      return state;
  }
}
